module.exports = __webpack_public_path__ + "media/images/dd-logo-nav-fb70c82a.svg";